import React, { ComponentProps } from "react";

import * as Styles from "./TextArea.styles";

type Props = ComponentProps<typeof Styles.TextArea>;

export const TextArea = (props: Props) => {
  return <Styles.TextArea {...props} className="px-3.5 py-2" />;
};
